import { Icon } from "@iconify/react";
import styleVariables from "@style_setup";
import _ from "lodash";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  PageLoader: (props) => ({
    width: "100%",
    height: !props.inPage ? "100vh" : "10rem",
    position: "relative",
    ..._.get(props, "customStyles.PageLoader", {}),
  }),
  loaderIcon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -80%)",
    fontSize: styleVariables.navbarHeight,
    color: "black",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});
export const PageLoader = ({ inPage = false }) => {
  const classes = styles({ inPage });
  return (
    <div className={classes.PageLoader}>
      <Icon icon="eos-icons:bubble-loading" className={classes.loaderIcon} />
    </div>
  );
};
PageLoader.propTypes = {
  inPage: PropTypes.bool,
};
